var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.title))])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, _vm._l(_vm.form.variables, function (variable, i) {
    return _c('b-form-group', {
      key: i,
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": variable.name || variable.key,
        "label-for": "type-name"
      }
    }, [_c('b-form-input', {
      staticClass: "mb-2 mr-sm-2 mb-sm-0",
      attrs: {
        "id": "type-name",
        "disabled": !_vm.hasLineMerchant
      },
      model: {
        value: variable.value,
        callback: function callback($$v) {
          _vm.$set(variable, "value", $$v);
        },
        expression: "variable.value"
      }
    })], 1);
  }), 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    }
  }, [_vm._v("取消")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.hasLineMerchant
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 儲存 ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }